export default __webpack_public_path__ + "static/media/gi-card-img3.4a58c8ca.png";